var React = require('react');

function ChevronRightGrey (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"d":"m10 18 6-6-6-6","stroke":"#9F9EAD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

ChevronRightGrey.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ChevronRightGrey;

ChevronRightGrey.default = ChevronRightGrey;
